const isBlank = (value) =>
    value == null || (typeof value === 'string' && value.trim() === '');

const pickFirst = (sources, keys) => {
    for (const source of sources) {
        if (!source || typeof source !== 'object') continue;
        for (const key of keys) {
            if (!isBlank(source[key])) return source[key];
        }
    }
    return null;
};

export const parseIsCumulated = (...values) => {
    for (const value of values) {
        if (value === true || value === 1 || value === 'true' || value === 'True') return true;
        if (value === false || value === 0 || value === 'false' || value === 'False') return false;
    }
    return false;
};

/**
 * prcp_is_cumulated = true  → cumul sur la période : prcp_trigger_low / prcp_trigger_sup (trigger_sup)
 * prcp_is_cumulated = false → horaire : prcp_trigger_hour_inf / trigger_hour_sup / prcp_trigger_number_hours
 * `sources` est parcouru dans l'ordre (ex. check claim puis sous-couverture).
 */
export const resolvePrecipTrigger = (isCumulatedValues, sources) => {
    const values = Array.isArray(isCumulatedValues) ? isCumulatedValues : [isCumulatedValues];
    const list = Array.isArray(sources) ? sources : [sources];
    const isCumulated = parseIsCumulated(...values);

    if (isCumulated) {
        return {
            isCumulated,
            mode: 'cumulative',
            modeLabel: 'Cumul sur la période',
            unit: 'mm',
            lowThreshold: pickFirst(list, ['prcp_trigger_low', 'trigger_low']),
            upperThreshold: pickFirst(list, ['prcp_trigger_sup', 'trigger_sup']),
            hours: null,
        };
    }

    return {
        isCumulated,
        mode: 'hourly',
        modeLabel: 'Horaire',
        unit: 'mm/h',
        lowThreshold: pickFirst(list, ['prcp_trigger_hour_inf']),
        upperThreshold: pickFirst(list, ['trigger_hour_sup']),
        hours: pickFirst(list, ['prcp_trigger_number_hours', 'trigger_number_hours']),
    };
};
